<div class="c-multiGameChallengesStart">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-multiGameChallengesStart__container">
    <div
      class="c-multiGameChallengesStart__background"
      theming
      themingGroup="gamechallenges"
      themingAsset="start-background"
      [themingOverride]="event?.assets">
      <div class="c-multiGameChallengesStart__info">
        <div
          class="c-multiGameChallengesStart__icon"
          theming
          themingGroup="gamechallenges"
          themingAsset="logo"
          [themingOverride]="event?.assets"></div>

        <div class="c-multiGameChallengesStart__text">
          <span class="text title">{{
            'home.live-ops.multichallenges.modal-start.title' | translate | uppercase
          }}</span>
          <span class="text subtitle">
            {{ 'home.live-ops.multichallenges.modal-start.subtitle' | translate | uppercase }}
          </span>
        </div>

        <div class="c-multiGameChallengesStart__timer">
          <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
          <slotcom-animated-timer
            [showInDays]="true"
            [endDate]="multiGameChallengesStartModalData.expirationDate"
            (expired)="closeModal()"></slotcom-animated-timer>
        </div>
      </div>

      <slotcom-button
        class="c-button--pink"
        (safeClick)="openMultiGameChallenges()"
        audioType="functionality">
        {{
          multiGameChallengesStartModalData.properties.buttonText[lang]
            ? multiGameChallengesStartModalData.properties.buttonText[lang]
            : ('home.buttons.discover-it' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
